import { LandingPurposes } from "../enums";

export interface LandingPageGetDto {
  id: number;
  name: string;
  content: string;
  publishedDate: string; // Date in ISO format
  purpose: LandingPurposes;
}
